import React from 'react';
import { useNavigate } from 'react-router-dom';

const FarmerTechChallenge = () => {
  const navigate = useNavigate();

  return (
    <div className="startup-showcases-page">
      {/* Header Section */}
      <div className="page-header">
        <div className="container">
          <button className="back-button" onClick={() => navigate(-1)}>
            <i className="fas fa-arrow-left"></i> Back to AgConverge
          </button>
          <div className="header-content">
            <div className="icon-large">🚜</div>
            <h1>Farmer Tech Adoption Challenge</h1>
            <p className="subtitle">Producer-led technology evaluation competition</p>
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <section className="content-section">
        <div className="container">
          <div className="content-card">
            <h2>Overview and Goals</h2>
            <p>
              The Farmers Tech Adoption Challenge is a first-of-its-kind designed farmer-led
              competition focused on how technology works in real farm operations.
            </p>

            <h3>How is it Different?</h3>
            <p>
              It flips the traditional startup pitch competition: instead of startups competing
              for prizes, farmers take the charge here.
            </p>

            <h3>Here's How It Works</h3>
            <p>
              Startups present their pitches, and farmers are matched with the companies that
              address their challenges or pain points. Farmers then evaluate the technologies,
              thinking about how they may or may not fit into their operations, whether the
              tools are usable, and if they would adopt them and why.
            </p>

            <h3>What Startups Get</h3>
            <p>
              This setup gives startups something they rarely get: straight, practical feedback
              from the people who would actually use their tools. And it gives farmers the chance
              to guide how these technologies develop and improve.
            </p>

            <p>
              By the end of the session, each farmer table will have produced a clear adoption
              decision, specific feedback for startups, and in some cases, commitments to try
              a technology on their farm. The top three roundtables will be recognized for the
              quality of their feedback and commitments and will win prizes.
            </p>

            <h3>The Ultimate Goal</h3>
            <p>
              The ultimate goal is to understand grower's pain points, identify what it would
              take for new technologies to be adopted, and ensure that innovations are guided
              by the needs of the people who use them.
            </p>
          </div>

          {/* Objectives Section */}
          <div className="content-card">
            <h2>Objectives</h2>
            <p>
              The challenge aims to identify grower's pain points and match them to pitched solutions
              from participating startups. Through structured evaluation sessions, we seek to produce
              actionable feedback for startups while identifying realistic farmer commitments to adopt
              new technologies and the behavioral or practice changes that would accompany adoption.
            </p>
            <p>
              A key focus is capturing any commitments to adopt the technology or work with startups
              when farmers agree the solution fits their needs. By creating a competitive environment,
              we motivate deeper analysis and encourage clear, valuable outputs that benefit both farmers
              and technology developers.
            </p>
          </div>

          {/* How It Works Section */}
          <div className="categories-section">
            <h2>How The Challenge Works</h2>
            <div className="categories-list">
              <div className="category-tag">1️⃣ Watch Startup Pitches</div>
              <div className="category-tag">2️⃣ Match with Relevant Technologies</div>
              <div className="category-tag">3️⃣ Evaluate Fit for Your Farm</div>
              <div className="category-tag">4️⃣ Provide Detailed Feedback</div>
              <div className="category-tag">5️⃣ Make Adoption Decisions</div>
              <div className="category-tag">6️⃣ Compete for Recognition</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FarmerTechChallenge;